import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { GenericFormFields } from '../../interface/generic.interface';
import { setNoPrompt } from '../../data-access/services/session-prompt.service';
@Component({
  selector: 'idp-generic-form',
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.scss']
})
export class GenericFormComponent implements AfterViewInit {
  @Input() genericFormFields: GenericFormFields = {} as GenericFormFields;
  @ViewChild('genericRedirectForm')
  genericRedirectForm!: ElementRef<HTMLFormElement>;

  ngAfterViewInit(): void {
    setNoPrompt();
    this.genericRedirectForm?.nativeElement.submit();
  }
}
